module.exports = __webpack_public_path__ + "media/15s.280f67ba.mp3";